<template>
  <a-drawer width="40%" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item label="系统用户" prop="sysUserId">
        <a-select
          v-model="form.sysUserId"
          show-search
          :filter-option="false"
          :not-found-content="userFetchLoading ? undefined : '无匹配用户'"
          placeholder="输入账号、昵称或手机号搜索并选择"
          allow-clear
          @search="onUserSearch"
          @dropdownVisibleChange="onUserDropdownOpen"
        >
          <a-spin v-if="userFetchLoading" slot="notFoundContent" size="small" />
          <a-select-option v-for="u in userOptions" :key="u.id" :value="Number(u.id)">
            {{ userOptionLabel(u) }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAnnouncementAuditor, addAnnouncementAuditor, updateAnnouncementAuditor } from '@/api/diandian/announcementAuditor'
import { pageUser, getUser } from '@/api/system/user'

export default {
  name: 'AnnouncementAuditorCreateForm',
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      open: false,
      form: {
        id: null,
        sysUserId: undefined,
        tenantId: 0
      },
      rules: {
        sysUserId: [{ required: true, message: '请选择系统用户', trigger: 'change' }]
      },
      userOptions: [],
      userFetchLoading: false,
      userSearchTimer: null
    }
  },
  beforeDestroy () {
    if (this.userSearchTimer) {
      clearTimeout(this.userSearchTimer)
    }
  },
  methods: {
    userOptionLabel (u) {
      const name = u.nickName || '-'
      const account = u.userName || '-'
      const phone = u.phoneNumber || '-'
      return `${name} / ${account} / ${phone}`
    },
    onUserDropdownOpen (open) {
      if (open && this.userOptions.length === 0) {
        this.fetchUsers('')
      }
    },
    onUserSearch (value) {
      if (this.userSearchTimer) {
        clearTimeout(this.userSearchTimer)
      }
      this.userSearchTimer = setTimeout(() => {
        this.fetchUsers(value)
      }, 300)
    },
    fetchUsers (keyword) {
      this.userFetchLoading = true
      const params = {
        pageNum: 1,
        pageSize: 50,
        status: 1
      }
      const k = (keyword || '').trim()
      if (k) {
        if (/^\d{3,}$/.test(k)) {
          params.phoneNumber = k
        } else if (/[\u4e00-\u9fa5]/.test(k)) {
          params.nickName = k
        } else {
          params.userName = k
        }
      }
      pageUser(params).then(res => {
        const records = (res.data && res.data.records) || []
        this.userOptions = records
        const selectedId = this.form.sysUserId
        if (selectedId != null && !this.userOptions.some(u => Number(u.id) === Number(selectedId))) {
          this.ensureSelectedUserInOptions(selectedId)
        }
      }).finally(() => {
        this.userFetchLoading = false
      })
    },
    ensureSelectedUserInOptions (userId) {
      getUser(userId).then(res => {
        const u = res.data
        if (!u || u.id == null) {
          return
        }
        if (this.userOptions.some(x => Number(x.id) === Number(u.id))) {
          return
        }
        this.userOptions = [{
          id: u.id,
          nickName: u.nickName,
          userName: u.userName,
          phoneNumber: u.phoneNumber
        }, ...this.userOptions]
      })
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        id: null,
        sysUserId: undefined,
        tenantId: 0
      }
      this.userOptions = []
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd () {
      this.reset()
      this.open = true
      this.formTitle = '新增公告审核人'
    },
    handleUpdate (row, ids) {
      this.reset()
      const id = row ? row.id : ids
      getAnnouncementAuditor({ id: id }).then(response => {
        const d = response.data || {}
        this.form = {
          id: d.id,
          sysUserId: d.sysUserId != null ? Number(d.sysUserId) : undefined,
          tenantId: d.tenantId != null ? d.tenantId : 0
        }
        if (this.form.sysUserId != null) {
          this.userOptions = [{
            id: this.form.sysUserId,
            nickName: d.nickName,
            userName: d.userName,
            phoneNumber: d.phoneNumber
          }]
        }
        this.open = true
        this.formTitle = '修改公告审核人'
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        const payload = { ...this.form }
        if (payload.id) {
          updateAnnouncementAuditor(payload).then(() => {
            this.$message.success('修改成功', 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          delete payload.id
          addAnnouncementAuditor(payload).then(() => {
            this.$message.success('新增成功', 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
